import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import styles from './contactsDetailsSection.module.scss';
export function ContactsDetailsSection({ headline, className, children, }) {
    return (_jsxs("article", Object.assign({ className: classnames(styles.root, className) }, { children: [headline && (_jsx(Text.Heading, Object.assign({ className: styles.headline }, { children: headline }))), _jsx("section", { children: children })] })));
}
